import { DataCard } from '@/reports/index';
import {
  build as buildDataCardBadge,
  DataCardBadgeTruthinessMapping,
} from '@/reports/shared/DataCard/DataCardBadge/DataCardBadge';
import {
  build as buildTag,
  DataCardTagTruthinessMapping,
} from '@/reports/shared/DataCard/DataCardTag/DataCardTag';
import { peopleTypes } from '@/reports/types';
import { DataList } from '@/theme/components';
import { getDatesSeen } from '@/utils/index';
import { isNewInfoItem } from '@/utils/isNewInfoItem/isNewInfoItem';

interface JobCardProps {
  job: peopleTypes.Job;
  thumbRating: () => JSX.Element;
}

export const JobCard: React.FC<JobCardProps> = ({ job, thumbRating }) => {
  const datesSeen = getDatesSeen(job);

  const badge = () => {
    const badgeMapping: DataCardBadgeTruthinessMapping[] = [
      {
        name: 'bestMatch',
        truthiness: job?.meta?.is_best || false,
        insert: 'Job',
      },
    ];

    return buildDataCardBadge(badgeMapping);
  };

  const tag = () => {
    const tagMapping: DataCardTagTruthinessMapping[] = [
      {
        name: 'newInfo',
        truthiness: isNewInfoItem({
          newInfo: job?.new_info,
          monitoredChangeType: job?.meta?.monitored_change_type,
          monitoredOn: job?.meta?.monitored_on,
        }),
      },
    ];

    return buildTag(tagMapping);
  };

  return (
    <DataCard
      tag={tag()}
      badge={badge()}
      thumbRating={thumbRating}
      titleProps={{ title: job.company || '' }}
      // TODO: Could navigate to a search for the business
      // But this is beyond parity, so hide for V1
      //
      // buttonProps={{ label: 'Search Business' }}
      cardStyles={{ mb: 0 }}
    >
      <DataList
        items={[
          ['Title', job.title],
          ['Dates seen', datesSeen],
        ]}
      />
    </DataCard>
  );
};
